(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cs-dynamic-collection-showcase"] && !Shopify.designMode) return;
  try {
    
  if (!window.csCollectionShowcaseReady) {
    window.csCollectionShowcaseReady = true;

    const initializeShowcase = (root) => {
      if (!root || root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      const rows = Array.from(root.querySelectorAll('[data-showcase-row]'));
      const motionEnabled = root.dataset.motion === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (!motionEnabled || !('IntersectionObserver' in window)) {
        rows.forEach((row) => row.classList.add('is-visible'));
        return;
      }

      root.classList.add('is-motion-ready');

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { rootMargin: '160px 0px', threshold: 0.01 });

      rows.forEach((row) => {
        observer.observe(row);
        const visual = row.querySelector('[data-showcase-visual]');
        if (!visual || !window.matchMedia('(pointer: fine)').matches) return;

        visual.addEventListener('pointermove', (event) => {
          const bounds = visual.getBoundingClientRect();
          const x = (event.clientX - bounds.left) / bounds.width - 0.5;
          const y = (event.clientY - bounds.top) / bounds.height - 0.5;
          visual.style.transform = `perspective(1000px) rotateX(${y * -3}deg) rotateY(${x * 4}deg)`;
        });

        visual.addEventListener('pointerleave', () => {
          visual.style.transform = '';
        });
      });
    };

    const initializeAllShowcases = (scope = document) => {
      scope.querySelectorAll('.cs-collection-showcase').forEach(initializeShowcase);
    };

    initializeAllShowcases();
    document.addEventListener('shopify:section:load', (event) => initializeAllShowcases(event.target));
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["halloween-saber-popup"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const popupDelay = 1500;
    const popupShells = document.querySelectorAll('[data-halloween-saber-popup]');

    popupShells.forEach((shell) => {
      if (shell.dataset.initialized === 'true') return;
      shell.dataset.initialized = 'true';

      const dialog = shell.querySelector('dialog');
      const closeButton = shell.querySelector('[data-popup-close]');
      const countdownValues = {
        days: shell.querySelector('[data-countdown-value="days"]'),
        hours: shell.querySelector('[data-countdown-value="hours"]'),
        minutes: shell.querySelector('[data-countdown-value="minutes"]'),
        seconds: shell.querySelector('[data-countdown-value="seconds"]'),
      };
      let previousFocus = null;
      let countdownTarget = null;
      let fallbackSessionShown = false;
      const popupSessionKey = 'christmas-saber-popup-shown';
      const countdownTimeZone = 'America/New_York';
      const countdownFormatter = new Intl.DateTimeFormat('en-US', {
        timeZone: countdownTimeZone,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hourCycle: 'h23',
      });

      const getZonedParts = (date) => {
        const parts = {};
        countdownFormatter.formatToParts(date).forEach((part) => {
          if (part.type !== 'literal') parts[part.type] = Number(part.value);
        });
        return parts;
      };

      const zonedTimeToUtc = (year, month, day, hour, minute, second) => {
        const desiredTime = Date.UTC(year, month - 1, day, hour, minute, second);
        let utcTime = desiredTime;

        for (let attempt = 0; attempt < 3; attempt += 1) {
          const actual = getZonedParts(new Date(utcTime));
          const actualTime = Date.UTC(
            actual.year,
            actual.month - 1,
            actual.day,
            actual.hour,
            actual.minute,
            actual.second
          );
          utcTime += desiredTime - actualTime;
        }

        return new Date(utcTime);
      };

      const getChristmasTarget = () => {
        const now = new Date();
        const newYorkYear = getZonedParts(now).year;
        let target = zonedTimeToUtc(newYorkYear, 12, 25, 0, 0, 0);

        if (now >= target) target = zonedTimeToUtc(newYorkYear + 1, 12, 25, 0, 0, 0);
        return target;
      };

      const setCountdownValue = (name, value) => {
        if (countdownValues[name]) countdownValues[name].textContent = String(value).padStart(2, '0');
      };

      const updateCountdown = () => {
        if (!countdownTarget || Date.now() > countdownTarget.getTime()) countdownTarget = getChristmasTarget();
        const remaining = Math.max(countdownTarget.getTime() - Date.now(), 0);
        const days = Math.floor(remaining / 86400000);
        const hours = Math.floor((remaining % 86400000) / 3600000);
        const minutes = Math.floor((remaining % 3600000) / 60000);
        const seconds = Math.floor((remaining % 60000) / 1000);

        setCountdownValue('days', days);
        setCountdownValue('hours', hours);
        setCountdownValue('minutes', minutes);
        setCountdownValue('seconds', seconds);
      };

      const hasShownPopup = () => {
        try {
          return window.sessionStorage.getItem(popupSessionKey) === 'true';
        } catch {
          return fallbackSessionShown;
        }
      };

      const rememberPopup = () => {
        fallbackSessionShown = true;
        try {
          window.sessionStorage.setItem(popupSessionKey, 'true');
        } catch {
          return;
        }
      };

      const openPopup = (remember = true) => {
        if (!dialog || dialog.open || (remember && hasShownPopup())) return;
        previousFocus = document.activeElement;
        dialog.showModal();
        if (remember) rememberPopup();
      };

      const closePopup = () => {
        if (!dialog || !dialog.open) return;
        dialog.close();
        if (previousFocus instanceof HTMLElement) previousFocus.focus();
      };

      const schedulePopup = () => {
        if (hasShownPopup()) return;
        window.setTimeout(() => openPopup(true), popupDelay);
      };

      closeButton?.addEventListener('click', closePopup);
      dialog?.addEventListener('click', (event) => {
        if (event.target === dialog) closePopup();
      });
      dialog?.addEventListener('close', () => {
        if (previousFocus instanceof HTMLElement) previousFocus.focus();
      });

      document.addEventListener('shopify:section:select', (event) => {
        if (event.detail.sectionId === shell.dataset.popupId) openPopup(false);
      });

      window.addEventListener('pageshow', (event) => {
        if (event.persisted) {
          updateCountdown();
          schedulePopup();
        }
      });

      updateCountdown();
      const countdownInterval = window.setInterval(updateCountdown, 1000);

      document.addEventListener('shopify:section:unload', (event) => {
        if (event.detail.sectionId === shell.dataset.popupId) window.clearInterval(countdownInterval);
      });

      schedulePopup();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
